import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import TextButton from "../../_components/atoms/text-button";
import { loadScript } from "../../_config/helper.config";
import { RootState } from "../../_store";

export const SUBSCRIPTION_CHECKOUT_PAGE = "/subscription/:options";

function PaymentCheckoutPageComponent({ user, community }: any) {
  const params = useParams();
  const [options, setOptions] = useState<any>(null);
  // @ts-ignore
  const base64Options = params.options;
  // @ts-ignore
  const RazorPay = window?.Razorpay;

  // Initialize Razorpay
  useEffect(() => {
    // @ts-ignore
    if (!RazorPay) {
      // load razorpay
      loadScript("https://checkout.razorpay.com/v1/checkout.js").then(
        async (result) => {
          if (!result) {
            alert("Could not load razorpay!");
            setTimeout(() => {
              // window.close();
            }, 1000);
          }
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RazorPay, window]);

  useEffect(() => {
    // @ts-ignore
    if (!window || !RazorPay || !base64Options) {
      return;
    }
    // convert base64 to json
    const optionsJson = JSON.parse(atob(base64Options));
    initiateCheckout(optionsJson);
    setOptions(optionsJson);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base64Options, RazorPay]);

  function initiateCheckout(optionsJson: any) {
    // @ts-ignore
    var paymentObject = new Razorpay(optionsJson) as any;
    paymentObject.open();
    paymentObject.on("payment.failed", (error: any) => {
      console.error("on Error", error);
    });
  }

  return (
    <div
      style={{
        zIndex: 120,
      }}
      className="SubscriptionCheckoutPage fixed inset-0 theme-bg-surface h-full flex gap-4 items-center place-content-center w-full">
      {/* <TextButton
        label="Cancel"
        hoverable
        onClick={() => {
          const isOk = window.confirm("Are you sure you want to cancel?");
          if (isOk) {
            window.close();
          }
        }}
      /> */}
      <TextButton
        label="Retry"
        className="bg-theme-primary theme-text-on-primary hover:theme-text-primary"
        disabled={!options}
        onClick={() => {
          initiateCheckout(options);
        }}
      />
    </div>
  );
}

const PaymentCheckoutPage = connect((state: RootState) => ({
  user: state.auth,
  community: state.community,
}))(PaymentCheckoutPageComponent);

export default PaymentCheckoutPage;
